let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iFl3h")).then(() => parcelRequire('4z4oh'));